export default __webpack_public_path__ + "static/media/roundClose.d88aea4a.svg";